import type { PlanFeatureInput } from '@frameio/graphql-client/generated';

/** Copy-link event group shared by every Upload link copy-link surface. */
export const UPLOAD_LINK_GROUP_ID = 'upload-link';

/** `method` values for the `upload-link-files-staged` Segment event. */
export const UPLOAD_LINK_STAGE_METHOD = {
  DragDrop: 'DragDrop',
  FileBrowser: 'FileBrowser',
} as const;

export type UploadLinkStageMethod =
  (typeof UPLOAD_LINK_STAGE_METHOD)[keyof typeof UPLOAD_LINK_STAGE_METHOD];

/** `limit_type` values the public uploader adds to the `upload-limit-enforced` event. */
export const UPLOAD_LINK_LIMIT_TYPE = {
  FileCount: 'FileCount',
  FileSize: 'FileSize',
  FolderDepth: 'FolderDepth',
} as const;

export type UploadLinkLimitType =
  (typeof UPLOAD_LINK_LIMIT_TYPE)[keyof typeof UPLOAD_LINK_LIMIT_TYPE];

/**
 * `source` surfaces an upload link can be created from (`upload-link-created`)
 * or copied from (`upload-link-copied`), one per surface.
 */
export const UPLOAD_LINK_SOURCE = {
  FolderContextMenu: 'FolderContextMenu',
  BottomActionBar: 'BottomActionBar',
  ManagePage: 'ManagePage',
  FinderSubmenu: 'FinderSubmenu',
  UploadLinkModal: 'UploadLinkModal',
} as const;

export type UploadLinkCreatedSource =
  (typeof UPLOAD_LINK_SOURCE)[keyof typeof UPLOAD_LINK_SOURCE];

/** `page_shown` states for the `upload-link-page-viewed` Segment event. */
export const UPLOAD_LINK_PAGE_SHOWN = {
  LandingPage: 'LandingPage',
  PassphrasePage: 'PassphrasePage',
  UnavailablePage: 'UnavailablePage',
} as const;

export type UploadLinkPageShown =
  (typeof UPLOAD_LINK_PAGE_SHOWN)[keyof typeof UPLOAD_LINK_PAGE_SHOWN];

/** Plan feature that entitles an account to Upload Links. */
export const UPLOAD_LINKS_PLAN_FEATURE: PlanFeatureInput = 'UPLOAD_LINKS';
